export default function NoPermissions(): React.ReactElement {
    return (
        <div style={{color: "black", textAlign: "center", marginTop: "50px"}}>
            <h1 style={{fontSize: "1.4rem"}}>Error</h1>
            <p style={{fontSize: "1.2rem"}}>You do not have permission to view this page.</p>
        </div>
    );
}